<template>
  <div
    :class="{ 'brightness-95': this.$store.state.displayEditLeGeneral }"
    class="box col-span-6"
    v-if="legalEntity"
  >
    <div
      class="text-left lg:text-left p-5 border-t border-gray-200 dark:border-dark-5"
    >
      <p
        v-if="
          this.$store.state.activeLE.ingestionConfig?.creditNoteNegative ===
            undefined &&
          this.$store.state.activeLE.ingestionConfig?.addZeroTaxSegments ===
            undefined &&
          this.$store.state.activeLE.ingestionConfig?.peppolFirstConfig ===
            undefined
        "
        class="error"
      >
        No legal entity settings configured for negative creditnote/add zero tax
        segments/peppol first, values are taken from suppliergroup
      </p>
      <div class="flex flex-row flex-nowrap">
        <div class="flex flex-col w-1/2 mr-12">
          <div class="mb-3 flex">
            <label class="font-bold text-lg form-label mb-0 mr-2"
              >Negative creditnote:
            </label>
            <ToggleSlide
              class="w-min pointer-events-none"
              :key="creditNoteNegative"
              :bool="creditNoteNegative"
              :disabled="true"
            />
          </div>
          <div class="mb-3 flex">
            <label class="font-bold text-lg form-label mb-0 mr-2"
              >Add zero tax segments:
            </label>
            <ToggleSlide
              class="w-min pointer-events-none"
              :key="addZeroTaxSegments"
              :bool="addZeroTaxSegments"
              :disabled="true"
              :renew-bool="true"
            />
          </div>
          <div class="mb-3 flex">
            <label class="font-bold text-lg form-label mb-0 mr-2"
              >Peppol first:
            </label>
            <ToggleSlide
              class="w-min pointer-events-none"
              :key="peppolFirstConfig"
              :bool="peppolFirstConfig"
              :renew-bool="true"
              :disabled="true"
            />
          </div>
          <div class="mb-3 flex">
            <label class="font-bold text-lg form-label mb-0 mr-2">
              API configuration:
            </label>
            <ToggleSlide
              class="w-min pointer-events-none"
              :key="apiConfigComputed"
              :bool="apiConfigComputed"
              :disabled="true"
            />
          </div>
          <div class="mb-3 flex" v-if="apiConfigComputed">
            <button
              class="btn bg-theme-1 text-white btn-sm w-24 mr-1 mb-2"
              id="clearCache"
              @click="clearCache"
            >
              Clear Cache
            </button>
          </div>
          <Field
            v-if="apiConfigComputed"
            class="ml-6"
            @copy="copy('apiKey')"
            :isCopied="copied.apiKey"
            :copySuffix="true"
            id="apiKey"
            title="API Key:"
            type="text"
            :modelValue="apiKey"
            :disabled="true"
          />
          <div class="mb-3 ml-6 flex">
            <p class="font-bold text-lg form-label mb-0 mr-2">
              OpenID Connect apisix:
            </p>
            <ToggleSlide
              class="w-min"
              :key="oidcEnabled"
              :bool="oidcEnabled"
              :disabled="true"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="absolute right-5 top-4">
      <button
        class="btn shadow-md bg-theme-1 text-white right-2"
        @click="resetIngestionSettings"
      >
        Reset
      </button>
    </div>
  </div>
</template>
<script>
import ToggleSlide from "@/components/ToggleSlide.vue";
import Field from "@/components/Field.vue";

export default {
  name: "ViewIngestion",
  components: { Field, ToggleSlide },
  data() {
    return {
      legalEntity: this.$store.state.activeLE,
      copyName: false,
      copyLe: false,
      copyBrandingId: false,
      creditNoteNegative: false,
      addZeroTaxSegments: false,
      peppolFirstConfig: false,
      apiConfigComputed: !!this.$store.state.activeLE.apiConfig,
      apiKey: null,
      oidcEnabled: false,
      copied: {
        apiKey: false,
      },
    };
  },
  mounted() {
    this.initData();
  },
  watch: {
    "$store.state.activeLE": {
      handler(data) {
        this.legalEntity = data;
        this.initData();
      },
      deep: true,
    },
  },
  methods: {
    initData() {
      if (
        this.$store.state.activeLE.ingestionConfig?.creditNoteNegative !==
        undefined
      )
        this.creditNoteNegative =
          this.$store.state.activeLE.ingestionConfig.creditNoteNegative;
      else if (this.$store.state.activeSG.storageConfig.creditNoteNegative)
        this.creditNoteNegative =
          this.$store.state.activeSG.storageConfig.creditNoteNegative;
      else this.creditNoteNegative = false;

      if (
        this.$store.state.activeLE.ingestionConfig?.addZeroTaxSegments !==
        undefined
      )
        this.addZeroTaxSegments =
          this.$store.state.activeLE.ingestionConfig.addZeroTaxSegments;
      else if (this.$store.state.activeSG.storageConfig.addZeroTaxSegments)
        this.addZeroTaxSegments =
          this.$store.state.activeSG.storageConfig.addZeroTaxSegments;
      else this.addZeroTaxSegments = false;

      if (
        this.$store.state.activeLE.ingestionConfig?.peppolFirstConfig
          ?.enabled !== undefined
      )
        this.peppolFirstConfig =
          this.$store.state.activeLE.ingestionConfig.peppolFirstConfig.enabled;
      else if (
        this.$store.state.activeSG.storageConfig?.peppolFirstConfig?.enabled
      )
        this.peppolFirstConfig =
          this.$store.state.activeSG.storageConfig.peppolFirstConfig.enabled;
      else this.peppolFirstConfig = false;

      this.apiConfigBool = !!this.$store.state.activeLE.apiConfig;
      this.apiKey = this.$store.state.activeLE.apiConfig?.apiKey
        ? this.$store.state.activeLE.apiConfig.apiKey
        : null;
      this.oidcEnabled = this.$store.state.activeLE.apiConfig?.oidcEnabled
        ? this.$store.state.activeLE.apiConfig.oidcEnabled
        : false;
    },
    copy(isFor) {
      if (isFor === "apiKey") {
        navigator.clipboard.writeText(this.apiKey);
        this.copied.apiKey = true;
        setTimeout(() => {
          this.copied.apiKey = false;
        }, 750);
      }
    },
    clearCache() {
      this.$store
        .dispatch("globalActions/clearCache")
        .catch((err) => console.error(err));
    },
    resetIngestionSettings() {
      const payload = {
        supplierGroupId: this.$store.state.activeSG.supplierGroupId,
        legalEntityId: this.$store.state.activeLE.entityNumber,
        ingestionSettings: {},
      };
      if (this.$store.state.activeLE.apiConfig)
        payload.ingestionSettings.apiConfig =
          this.$store.state.activeLE.apiConfig;

      this.$store.dispatch("EditLegalEntityIngestion", payload);
    },
  },
};
</script>
